export const NAME = "transactions"
export const FIREBASE_PATH = "transactions"
